// src/icons/Terminal.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Terminal({
  strokeWidth = "2.28571",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.33337 23.3333L14.6667 16L7.33337 8.66663M16.6667 26H26",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  Terminal
};
